import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, EffectFade } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

import { Box, Button, useTheme } from '@mui/material'
import EastIcon from '@mui/icons-material/East'
import SplitText from '../../../../SplitText'
import BlurText from '../../../../BlurText'
import TextPressure from '../../../../TextPressure'

import bgMain9 from '../../../../../assets/images/arbol-ec/fondos/DJI_06.jpg'
import bgMain8 from '../../../../../assets/images/arbol-ec/fondos/DJI_05.jpeg'
import bgMain13 from '../../../../../assets/images/arbol-ec/fondos/013.jpg'
import bgMain10 from '../../../../../assets/images/arbol-ec/fondos/DSL_10.jpg'
import bgMain5 from '../../../../../assets/images/arbol-ec/fondos/021.jpg'
import bgMain4 from '../../../../../assets/images/arbol-ec/fondos/020.jpg'
import bgMain19 from '../../../../../assets/images/arbol-ec/fondos/019.jpg'
import ButtonMain from './ButtonMain'

import { useNavigate } from 'react-router-dom'

const images = [bgMain9, bgMain8, bgMain13, bgMain10, bgMain5, bgMain4, bgMain19]
const enableLoop = images.length >= 4

const HeroComponent = ({
  title = 'Título',
  subtitle = 'Subtítulo',
  height = '100vh',
  width = '100vw',
  slideInterval = 4900,
  transitionSpeed = 1200,
}) => {
  const navigate = useNavigate()
  const theme = useTheme()

  return (
    <Box
      sx={{
        position: 'relative',
        height,
        width,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}>
      {/* Fondo con Swiper y overlay */}
      <Swiper
        loop={enableLoop}
        effect="fade"
        speed={transitionSpeed}
        autoplay={{ delay: slideInterval, disableOnInteraction: false }}
        modules={[Autoplay, EffectFade]}
        style={{
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 1,
        }}>
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <Box
              className="swiper-slide-content"
              sx={{
                width: '100%',
                height: '100%',
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative',
              }}>
              {/* overlay visual */}
              <Box
                className="overlay overlay-a"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background:
                    'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5))',
                  zIndex: 2,
                }}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Contenido */}
      <Box sx={{ position: 'relative', zIndex: 3, width: '80vw' }}>
        {
          <TextPressure
            text={`Árbol\u00A0Ec.`}
            flex={false}
            alpha={true}
            stroke={false}
            width={true}
            weight={true}
            italic={true}
            textColor="#ffffff"
            strokeColor="#ff0000"
            minFontSize={50}
          />
        }
      </Box>

      <Box
        px={6}
        sx={{
          position: 'absolute',
          bottom: 30,
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          width: '100%',
          color: 'white',
          zIndex: 3,
        }}>
        <SplitText
          text={title}
          delay={100}
          duration={2}
          ease="power3.out"
          splitType="lines"
          from={{ opacity: 0, x: 40 }}
          to={{ opacity: 1, x: 0 }}
          variant="h1"
          textAlign="center"
          sx={{
            color: theme.palette.secondary.light,
            fontWeight: 600,

            mb: 3,
            textShadow: '0 0 1px rgba(255, 255, 255, 0.8)',
          }}
        />

        <BlurText
          text={subtitle}
          animateBy="words"
          delay={40}
          variant="h4"
          textAlign="center"
          sx={{ color: '#ffffff', fontWeight: 600, justifyContent: 'center', pb: 2 }}
        />

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Button
            variant="outlined"
            size="small"
            endIcon={<EastIcon sx={{ fontSize: '0.9rem' }} />}
            onClick={() => navigate('/ec/loja')}
            sx={{
              borderRadius: 50,
              border: '1px solid rgba(255,255,255,0.45)',
              color: 'rgba(255,255,255,0.85)',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.85rem',
              px: 2.5,
              py: 0.6,
              backdropFilter: 'blur(4px)',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.12)',
                border: '1px solid rgba(255,255,255,0.75)',
                color: '#fff',
              },
              transition: 'all 0.25s ease',
            }}>
            Explorar mapa
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default HeroComponent
